export default "__VITE_ASSET__BwXc6tVC__"